import { makeKeyValueRepository } from '../../../data/repositories/key-value/key-value-repository-factory';
import { makeEventService } from '../../../data/services/common/event/event-service-factory';
import { makeLogService } from '../../../data/services/common/log/log/log-service-factory';
import { SelectEntityUseCase } from './select-entity-use-case';

export function makeSelectEntityUseCase() {
  return new SelectEntityUseCase(
    makeLogService(),
    makeKeyValueRepository(),
    makeEventService(),
  );
}
